import { AbstractControl, FormGroup } from '@angular/forms';

export interface SelectOption {
  label: string;
  value: string;
}

export const CLEAR_OPTION: SelectOption = { label: "-- Clear --", value: "CLEAR_VALUES" };

export function applyClearOption(options: SelectOption[], currentValue: any): SelectOption[] {
  const opts = [...options];
  const showClear = !(currentValue == "" && typeof currentValue == "string") && currentValue != null;
  const hasClear = opts[0]?.value === CLEAR_OPTION.value;

  if (!showClear && hasClear) {
    opts.shift();
  } else if (showClear && !hasClear) {
    opts.unshift(CLEAR_OPTION);
  }
  return opts;
}

export function isProvinceOrJurisdictionField(fieldName: string): boolean {
  return fieldName.includes("Province") || fieldName.includes("Jurisdiction");
}

export function findCountryFilterControl(parent: AbstractControl): AbstractControl | null {
  if (!parent || !('controls' in parent)) {
    return null;
  }
  const group = parent as FormGroup;
  const countryKey = Object.keys(group.controls).find(key =>
    (key.includes("Country") || key.includes("CountryCd")) &&
    !key.includes("Province") &&
    !key.includes("Jurisdiction")
  );
  return countryKey ? group.get(countryKey) : null;
}
